import React from "react";
import { Box } from "@mui/system";
import useMakeScrollable from "custom_hooks/make-scrollable";
import BlueBoxBig from "components/shared/BlueBoxBig";
import SurveyList from "./SurveyList";




function Surveys() {
  useMakeScrollable();
  
  return (
    <div data-testid="news">
      <div className="scrollable">
        <Box>
          <BlueBoxBig text="Offene Umfragen" />
          <SurveyList />
        </Box>
      </div>
    </div>
  );
}



export default Surveys;
